import mutations from './appointmentHistory.mutations'
import actions from './appointmentHistory.actions'
import getters from './appointmentHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
